import { render } from "./AppJoin.vue?vue&type=template&id=50d8b9d7"
import script from "./AppJoin.vue?vue&type=script&lang=js"
export * from "./AppJoin.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__